module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core.module/modules/panel.module/panel-controls/panel-controls.component.css
// module id = ./src/app/core.module/modules/panel.module/panel-controls/panel-controls.component.css
// module chunks = main